import { GENDER } from "../constants/Common";

export const formatCurrencyValue = (value: string, showZero = false, isNegative = false) => {
  return value === '0' ? (showZero ? getCurrencyFormat(value) : '※') : (isNegative ? '-' : '') + getCurrencyFormat(value);
}

const getCurrencyFormat = (value: string) => {
  return new Intl.NumberFormat('ja-JP', { style: 'currency', currency: 'JPY', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(parseInt(value));
}

export const formatWholeNumber = (value: string, showZero = true) => {
  return value === "0" && !showZero ? "-" : new Intl.NumberFormat().format(parseInt(value));
}

export const filterCurrency = (value: any) => {
  return (isNaN(value) || value === '') ? 0 : parseInt(value);
}

export const getTitleByGender = (gender: string): string => {
  return gender === null || gender === GENDER.MALE ? 'Mr.' : 'Mrs.';
}

export const getCategoryKeysByCity = (categories: string[]): string[] => {
  return categories?.map(category => `CITY_${category}`) || [];
}

export const isStringIncluded = (str: string, substr: string, position: number = 0): boolean => {
  let slice = str.slice(position, position + substr.length)
  return slice === substr;
}
